import { ComponentRenderHooks } from "@/plugins/types";
import Navigation from "./component";
import settings from "./settings";
import { ComponentTypes } from "@/Apps/Pages/Editor/types";
import {Properties, SimpleNavigationProperties} from "./Properties/Properties";

export const onListItems = (hook, payload, actions) => {
  if (hook.id === ComponentRenderHooks.WEBCOMPONENT) {
    return [settings];
  }
};

export const onComponentRender = (hook, payload, actions) => {
  if (
    hook.id === ComponentRenderHooks.WEBCOMPONENT &&
    payload.type === ComponentTypes.NAVIGATION
  ) {
    return [Navigation];
  }

  if (
    hook.id === ComponentRenderHooks.PROPERTIES &&
    hook.type === ComponentTypes.NAVIGATION
  ) {
    return Properties(payload);
  }

  if (
    hook.id === ComponentRenderHooks.SIMPLE_PROPERTIES &&
    hook.type === ComponentTypes.NAVIGATION
  ) {
    return SimpleNavigationProperties(payload);
  }
};
